import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, viewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';

import { AccountFacade } from 'ish-core/facades/account.facade';
import { GenerateLazyComponent } from 'ish-core/utils/module-loader/generate-lazy-component.decorator';
import { ModalDialogComponent } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';

import { DotCmsFacade } from '../../facades/dot-cms.facade';
import { CustomDotCmsContentlet } from '../../models/contentlet/custom-dotcms-contentlet.model';

@Component({
  selector: 'custom-dot-cms-footer',
  templateUrl: './dot-cms-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
@GenerateLazyComponent()
export class DotCmsFooterComponent implements AfterViewInit, OnDestroy {
  constructor(private dotcmsfacade: DotCmsFacade, private accountFacade: AccountFacade) {}

  readonly conformDialog = viewChild<ModalDialogComponent<any>>('conformDialog');
  contentlet$: Observable<CustomDotCmsContentlet> = this.dotcmsfacade.getFooterContentlet$();
  emailInput: HTMLInputElement;

  newsLetterForm = new FormGroup({
    newsletterEmail: new FormControl('', [Validators.required, Validators.email]),
  });

  private observer: MutationObserver;

  ngAfterViewInit() {
    this.observer = new MutationObserver(() => this.handelNewsletterSubmit());
    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  handelNewsletterSubmit() {
    this.emailInput = document.getElementById('newsletter_email') as HTMLInputElement;
    const submitButton = document.getElementById('signup_button') as HTMLInputElement;

    if (this.emailInput && submitButton) {
      submitButton.addEventListener('click', event => {
        event.preventDefault();
        this.newsLetterForm.get('newsletterEmail')?.setValue(this.emailInput.value);

        if (this.newsLetterForm.valid) {
          this.conformDialog().show();
        }
      });

      this.observer.disconnect();
    }
  }

  confirmMail() {
    this.accountFacade.updateNewsletterSubscription(true, this.emailInput.value, true);
    this.newsLetterForm.reset();
    if (this.emailInput) {
      this.emailInput.value = '';
    }
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
